import { useState, useEffect } from 'react';

export const useSteps = ({ doneData, watch, settings = {} }) => {
  const [steps, setSteps] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const currentStep = steps[currentStepIndex];

  useEffect(() => {
    autoStep();
  }, watch);


/*
  si currentStep.autoStep === true, no importa settings.autoStep, tiene que hacer autoStep
  si settings.autoStep === true, tiene que hacer autoStep

  si settings.autoStep === false, NO tiene que hacer autoStep

*/

  function autoStep() {
    
    if (!currentStep) return;

    const shouldAutoStep = (() => {
      if (currentStep.autoStep) return true;
      return settings.autoStep;
    })();

    if (!shouldAutoStep) return;

    const nextStep = steps.findIndex((step) => !step.done(doneData));
    if (nextStep) setCurrentStepIndex(nextStep);
  }

  return {
    autoStep,
    steps,
    setSteps,
    currentStep,
    currentStepIndex,
    setCurrentStepIndex,
  };
}

export const useMergeableState = (initial, options = {}) => {
  const [payload, setPayload] = useState(initial || {});

  function mergePayload(newPayload) {
    setPayload({
      ...payload,
      ...newPayload,
    });
  }
  return [
    payload,
    mergePayload,
  ];
}
